import { createAsyncTypes } from './mutation-types'

export default {
  POST_LOGIN: createAsyncTypes('POST_LOGIN'),
  POST_REFRESH: createAsyncTypes('POST_REFRESH'),
  GET_USER: createAsyncTypes('GET_USER'),
  PUT_USER: createAsyncTypes('PUT_USER'),
  POST_USER: createAsyncTypes('POST_USER'),
  POST_EMAIL_VERIFICATION: createAsyncTypes('POST_EMAIL_VERIFICATION'),
  GET_RESET_PASSWORD: createAsyncTypes('GET_RESET_PASSWORD'),
  POST_RESET_PASSWORD: createAsyncTypes('POST_RESET_PASSWORD'),
  POST_PARENTAL_CONSENT: createAsyncTypes('POST_PARENTAL_CONSENT'),
  POST_PARENTAL_CONSENT_EMAIL: createAsyncTypes('POST_PARENTAL_CONSENT_EMAIL'),
  GET_DASHBOARD: createAsyncTypes('GET_DASHBOARD'),
  GET_KITS: createAsyncTypes('GET_KITS'),
  GET_SUBSCRIPTIONS: createAsyncTypes('GET_SUBSCRIPTIONS'),
  GET_SENT_KITS: createAsyncTypes('GET_SENT_KITS'),
  POST_KIT_ACTIVATION: createAsyncTypes('POST_KIT_ACTIVATION'),
  POST_ORDER: createAsyncTypes('POST_ORDER'),
  GET_SURVEY: createAsyncTypes('GET_SURVEY'),
  GET_TOKEN: createAsyncTypes('GET_TOKEN'),
  GET_KIT_TIMELINE: createAsyncTypes('GET_KIT_TIMELINE'),
  GET_RECRUITMENT_CONSENT: createAsyncTypes('GET_RECRUITMENT_CONSENT'),
  POST_RECRUITMENT_CANDIDATE: createAsyncTypes('POST_RECRUITMENT_CANDIDATE'),
  PUT_RECRUITMENT_CANDIDATE_CONSENT: createAsyncTypes('PUT_RECRUITMENT_CANDIDATE_CONSENT')
}



// WEBPACK FOOTER //
// ./src/stores/types.js